import { Locale } from '@cars4ever/public-ui';

export const BUSINESS_TYPE = process.env.DIGITAL_DEALER_BUSINESS_TYPE;
export const API = process.env.DIGITAL_DEALER_API;
export const LOCALE = process.env.DIGITAL_DEALER_LOCALE as Locale;
export const CLOUD_NAME = process.env.DIGITAL_DEALER_CLOUD_NAME as string;
export const CAR_IMAGES_FOLDER_KEY = process.env.DIGITAL_DEALER_CAR_IMAGES_FOLDER_KEY as string;
export const APP_INSIGHTS_INSTRUMENTATION_KEY = process.env.DIGITAL_DEALER_APP_INSIGHTS_INSTRUMENTATION_KEY;
export const GOOGLE_MAPS_API_KEY = process.env.DIGITAL_DEALER_GOOGLE_MAPS_API_KEY as string;
export const GTM_ID = process.env.DIGITAL_DEALER_GTM_ID;
export const WIDGET_URL = process.env.DIGITAL_DEALER_WIDGET_URL as string;
export const BRAND_CONFIG_URL = process.env.DIGITAL_DEALER_BRAND_CONFIG_URL as string;
export const BANK_LOAN_MOCK_CONFIG_PERSONAL_CAR = process.env.DIGITAL_DEALER_BANK_LOAN_MOCK_CONFIG_PERSONAL_CAR as string;
export const BANK_LOAN_MOCK_CONFIG_VAN = process.env.DIGITAL_DEALER_BANK_LOAN_MOCK_CONFIG_VAN as string;
